import { useMemo } from "react";

export function useFilterableData<TData>(data: TData[] | undefined | null, term: string, filter?: (term: string) => (data: TData) => boolean) {

    const filteredData = useMemo(()=> {
        if (filter && data) {
            const dataFilter = filter(term || '');
            return data.filter(dataFilter);
        } else {
            return data;
        }
    },[filter, data, term])
    
    return filteredData;
}
